var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.44121H5.7913C6.01462 8.44121 6.19565 8.62224 6.19565 8.84555C6.19565 10.1734 7.27212 11.2499 8.6 11.2499H12.7304C14.0583 11.2499 15.1348 10.1734 15.1348 8.84555C15.1348 8.62224 15.3158 8.44121 15.5391 8.44121H19V15.3543C19 15.9065 18.5523 16.3542 18 16.3542H3C2.44772 16.3542 2 15.9065 2 15.3542V8.44121ZM15.1659 3.94897L15.8791 3.24804L15.1659 3.94897L17.6152 6.44121H15.5391C14.2112 6.44121 13.1348 7.51767 13.1348 8.84555C13.1348 9.06887 12.9537 9.2499 12.7304 9.2499H8.6C8.37668 9.2499 8.19565 9.06887 8.19565 8.84555C8.19565 7.51767 7.11919 6.44121 5.7913 6.44121H3.35556L5.75574 3.95531C5.94418 3.76013 6.20384 3.6499 6.47514 3.6499H14.4527C14.7209 3.6499 14.9779 3.75766 15.1659 3.94897Z",
    stroke: "#E6EAEB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.81f13737b0fbf94fdf1364fb0f3993dd.svg";
export { ForwardRef as ReactComponent };